// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://lmcryzaepztdqvtywfjs.supabase.co'
const supabaseAnonKey = 'sb_publishable_Dgi9nrRKib_bLmFBw1AyoA_QErAwdH0'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)